import { render, staticRenderFns } from "./ImageCollage.vue?vue&type=template&id=6f36dc4d&"
import script from "./ImageCollage.vue?vue&type=script&lang=js&"
export * from "./ImageCollage.vue?vue&type=script&lang=js&"
import style0 from "./ImageCollage.vue?vue&type=style&index=0&id=6f36dc4d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports